function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#254E97",
    fillOpacity: 0.2,
    style: {
      fill: "#254E97",
      fill: "color(display-p3 0.1451 0.3059 0.5922)",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 25.25C32.75 30.08 28.83 34 24 34C19.17 34 15.25 30.08 15.25 25.25C15.25 20.42 19.17 16.5 24 16.5C28.83 16.5 32.75 20.42 32.75 25.25Z",
    stroke: "#254E97",
    style: {
      stroke: "#254E97",
      stroke: "color(display-p3 0.1451 0.3059 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20V25",
    stroke: "#254E97",
    style: {
      stroke: "#254E97",
      stroke: "color(display-p3 0.1451 0.3059 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14H27",
    stroke: "#254E97",
    style: {
      stroke: "#254E97",
      stroke: "color(display-p3 0.1451 0.3059 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.2f0254277b51cbc438d412a755979d64.svg";
export { ForwardRef as ReactComponent };